import { ServiceAppError, ServiceParseError } from 'state/service/appTs/serviceErrors';
import { ServiceStateStrict } from 'state/service/app';
import { ServiceWebsocketAction, WebsocketActionPayload } from '/state/service/appTs/types';
import { assertNever } from '@tock/shared/utils/typeUtils';
import {
  decodeWebsocketActionPayload,
  websocketActionToClient,
} from 'state/service/appTs/decoders';
import { update } from './tmClient';
import defaultAppState from 'defaultAppState';

function inboundWebsocketMessage(
  state: ServiceStateStrict,
  action: WebsocketActionPayload
): ServiceStateStrict {
  try {
    const websocketAction = decodeWebsocketActionPayload(action);
    const clientAction = websocketActionToClient(websocketAction);
    return update(state, clientAction);
  } catch (e) {
    if (e instanceof ServiceAppError) {
      return {
        ...state,
        // TODO: figure out what to do with errors to match Elm implementation
        // error: e.displayMessage,
      };
    } else if (e instanceof ServiceParseError) {
      return {
        ...state,
        decodeError: e.message,
      };
    } else {
      throw e;
    }
  }
}

export default function serviceWebsocket(
  state: ServiceStateStrict = defaultAppState,
  action: ServiceWebsocketAction
): ServiceStateStrict {
  try {
    switch (action.type) {
      case 'SERVICE_WEBSOCKET_INBOUND_WEBSOCKET_MESSAGE':
        return inboundWebsocketMessage(state, action.payload);
      // istanbul ignore next
      default:
        return assertNever(action.type);
    }
  } catch (e) {
    if (e instanceof ServiceAppError) {
      return {
        ...state,
        error: e.displayMessage,
      };
    } else {
      throw e;
    }
  }
}
